import { cloneDeep, result } from 'lodash';
import { IAxisesAndLegendsResult } from './axisesAndLegends';

export function tryTranslateCaption(possibleCaption: string | number, translate: any): string {
			const possibleCaptions = possibleCaption?.toString().split(', ');
			const results = possibleCaptions?.map(caption => {
				const possibleTranslationKey = `apex.legend.${caption}`;
				const possibleTranslation = translate(possibleTranslationKey);
				if (possibleTranslation !== possibleTranslationKey)
					return possibleTranslation;

				return caption;
			});

			return results?.join(', ');
}
